import React, { useState, useEffect } from 'react'
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { useParams } from "react-router-dom";
import { visualizar } from '../../../../util/AcessoApi'
import { ModalPadraoCadastro } from '../../../../components/Modais';

const Visualizacao = (props) => {
    let { id } = useParams();
    const [dados, setDados] = useState()

    useEffect(() => {
        visualizar('/atendimento/prontuario', id,
            obj => {
                setDados(obj.id ? {
                    id,
                    modulo: props.modulo,
                    titulo: 'Visualização Prontuário',
                    grupos: [
                        {
                            titulo: 'Dados Gerais',
                            colunas: [
                                { titulo: 'Código', descricao: obj.id, tamanho: 'col-lg-4' },
                                { titulo: 'Paciente', descricao: obj.paciente, tamanho: 'col-lg-4' },
                                { titulo: 'Cooperado', descricao: obj.cooperado, tamanho: 'col-lg-4' },
                                { titulo: 'Última Consulta', descricao: obj.ultima_consulta, tamanho: 'col-lg-4' },
                            ]
                        },
                        {
                            tipoGrupo: 'tabela',
                            titulo: 'Histórico',
                            thead:
                                <tr>
                                    <td className='coluna-1'>Código</td>
                                    <td className='coluna-2'>Data</td>
                                    <td className='coluna-8'>Resumo</td>
                                </tr>,
                            tbody: obj?.historico?.map(item =>
                                <tr>
                                    <td>{item.id || '--'}</td>
                                    <td>{item.data_registro || '--'}</td>
                                    <td><div dangerouslySetInnerHTML={{ __html: item.resumo || '--' }}></div></td>
                                </tr>)
                        }
                    ]
                } : { titulo: 'Visualização Prontuário' })
            })
    }, [id])

    return dados ? <VisualizacaoPadrao data={dados} {...props} /> : null
}

const DetalhesAgendamento = (props) => {
    const [itemDetalhes, setItemDetalhes] = useState([]);
    const [historicoStatus, setHistoricoStatus] = useState([]);

    useEffect(() => {
        if (props.id) {
            visualizar(`/atendimento/agenda`, props.id, obj => {
                setItemDetalhes([{
                    titulo: 'Código',
                    descricao: obj.id
                },
                {
                    titulo: 'Status',
                    descricao: obj.status,
                },
                {
                    titulo: 'Data',
                    descricao: obj.data
                },
                {
                    titulo: 'Hora Inicial',
                    descricao: obj.hora_inicial
                },
                {
                    titulo: 'Hora Final',
                    descricao: obj.hora_final
                },
                {
                    titulo: 'Prestador',
                    descricao: obj?.prestador?.label
                },
                {
                    titulo: 'Paciente', descricao:
                        <ul className='lista-modal'>
                            <li className="mb-1">
                                <div className='mb-2'><span><b>Nome: </b>{obj.paciente?.nome}</span></div>
                                <div className='mb-2'><span><b>Telefone: </b>{obj.paciente?.telefone ?? '--'}</span></div>
                                <div className=''><span><b>Celular: </b>{obj.paciente?.celular ?? '--'}</span></div>
                            </li>
                        </ul>
                },
                {
                    titulo: 'Observação',
                    descricao: obj.observacao
                }])

                setHistoricoStatus(obj.historico_status || [])
            })
        } else {
            setItemDetalhes([])
        }
    }, [props])

    // useEffect(() => {
    //     if (!props.showModal) {
    //         setItemDetalhes([])
    //     }
    // }, [props.showModal])

    return <ModalPadraoCadastro titulo={props.titulo || 'Detalhes Agendamento'} showModal={props.showModal} setShowModal={props.setShowModal} clearModal={setItemDetalhes}>
        <div><div className='detalhes'>
            {itemDetalhes && itemDetalhes.map((item, idx) => {
                return (
                    <>
                        {idx === 0 ? <></> : <hr />}
                        <div className='item-detalhes'>
                            <h6><b>{item.titulo}</b></h6>
                            <h6>{item.descricao}</h6>
                            {item.html}
                        </div></>
                )
            })}
        </div>
            {
                historicoStatus && historicoStatus.length > 0 ?
                    <div className="modal-header">
                        <h5 className="modal-title"><span>Histórico de Status</span></h5>
                    </div>
                    : <></>
            }
            <div>
                <ul className='lista-modal'>
                    {
                        historicoStatus && historicoStatus.map(item => <li className="mb-1">
                            <div className='col-hora row-space-between'>
                                <span className={'tag'} style={{ background: item.cor, color: 'white' }}>{item.status}</span> <span className=''>{item.data_registro}</span>
                            </div>
                            <div className='mt-2'>
                                <i><p>{item.justificativa}</p></i>
                            </div>
                            <div className='col-hora row-space-between'>
                                <span></span>
                                <span className='span-nome'><b>{item.usuario}</b></span>
                            </div>
                        </li>)
                    }
                </ul>
            </div>
        </div>
    </ModalPadraoCadastro >
}

export { DetalhesAgendamento }

export default Visualizacao